"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var AdupTabButtonTitleLastUpdate = /** @class */ (function (_super) {
    __extends(AdupTabButtonTitleLastUpdate, _super);
    function AdupTabButtonTitleLastUpdate() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AdupTabButtonTitleLastUpdate.prototype.GetLastUpdateTime = function () {
        var TvsuLastRunTime = Cookies.get('TvsuLastRunTime');
        return TvsuLastRunTime;
    };
    ;
    AdupTabButtonTitleLastUpdate.prototype.render = function () {
        var lastUpdateTimeStr = this.GetLastUpdateTime();
        return React.createElement("div", { className: "dow-adup-last-update-container dow-adup-head-content", style: { display: lastUpdateTimeStr ? "block" : "none" } },
            React.createElement("span", null,
                l.Translator.translate("latest update date|Latest update date"),
                ":"),
            React.createElement("span", null, lastUpdateTimeStr));
    };
    return AdupTabButtonTitleLastUpdate;
}(React.Component));
exports.AdupTabButtonTitleLastUpdate = AdupTabButtonTitleLastUpdate;
